<section data-component="popup-site-info" role="dialog" [attr.aria-describedby]= "ariaDescribedBy">
  <h2 id="{{ariaTitleId}}" role="heading" [innerHTML]="infoContent?.copy$$info_covid_help_contact_message?.TEXT"></h2>
  <span class="separator separator-rule separator-large" aria-hidden="true"></span>
  <section data-form-id="info">
    <div class="button-box reverse-medium-min">
      <button class="secondary-large" 
              (click)="cancel()"
              [innerHTML] = "infoContent?.copy$$btn_no_thanks?.TEXT">
      </button>
      <button class="primary-large" 
              type="submit"
              (click)="continue()"
              [innerHTML] = "infoContent?.copy$$btn_yes_please?.TEXT">
      </button>
    </div>
  </section> 
</section>


